// Attribution & dataLayer-Utilities (Phase 1): UTM-Parameter + gclid/gbraid/wbraid
// aus der URL lesen, 90 Tage in localStorage halten, bei jedem Lead mitsenden.
const TRACK_KEY = "ue24_tracking";
const TTL_DAYS = 90;
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid"];

const COOKIE_NAME = "ue24_attr";

// First-Party-Cookie (90 Tage) zusätzlich zum localStorage – übersteht auch
// gelöschten Web-Storage und ist serverseitig lesbar, falls später nötig.
function setAttrCookie(value) {
  try {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; max-age=${TTL_DAYS * 86400}; path=/; SameSite=Lax`;
  } catch { /* Cookies blockiert */ }
}

function getAttrCookie() {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : "";
  } catch { return ""; }
}

export function captureAttribution() {
  try {
    const search = window.location.search;
    if (!search) return;
    const url = new URLSearchParams(search);
    const found = {};
    PARAMS.forEach((p) => { const v = url.get(p); if (v) found[p] = v; });
    if (!Object.keys(found).length) return;
    const prev = getAttribution() || {};
    const payload = JSON.stringify({
      ...prev, ...found,
      landing_page: prev.landing_page || window.location.pathname,
      ts: Date.now(),
    });
    localStorage.setItem(TRACK_KEY, payload);
    setAttrCookie(payload);
  } catch { /* storage nicht verfügbar */ }
}

export function getAttribution() {
  try {
    const raw = localStorage.getItem(TRACK_KEY) || getAttrCookie();
    if (!raw) return {};
    const data = JSON.parse(raw);
    if (!data.ts || Date.now() - data.ts > TTL_DAYS * 86400000) return {};
    return data;
  } catch { return {}; }
}

// Versteckte Lead-Felder für Offline-Conversions (gclid/gbraid/wbraid, UTM,
// Landingpage) – jede Formular-Übertragung reicht sie ans Backend durch.
export function attributionFields() {
  const a = getAttribution();
  return {
    utm_source: a.utm_source || "",
    utm_medium: a.utm_medium || "",
    utm_campaign: a.utm_campaign || "",
    gclid: a.gclid || "",
    gbraid: a.gbraid || "",
    wbraid: a.wbraid || "",
    landing_page: a.landing_page || "",
  };
}

// dataLayer für GTM (GTM-WSKX8ZZ) → Google Ads + GA4
export function dl(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

export async function sha256Hex(text) {
  if (!text || !window.crypto?.subtle) return "";
  const norm = text.trim().toLowerCase().replace(/\s+/g, "");
  const buf = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(norm));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
